import { EntitySimulation } from "../../entity/EntitySimulation";

export class DtoSimulationsPostRes extends EntitySimulation {}
